
import React, { useState, useEffect } from 'react';
import { useTranslation } from './contexts/translation';

interface TranslatedTextProps {
  text: string;
  className?: string;
  as?: keyof JSX.IntrinsicElements;
}

const TranslatedText: React.FC<TranslatedTextProps> = ({ 
  text, 
  className = '', 
  as: Component = 'span' 
}) => {
  const { translate, language, isTranslating } = useTranslation();
  const [translatedText, setTranslatedText] = useState(text);
  const [loading, setLoading] = useState(language !== 'en');
  const [error, setError] = useState(false);

  useEffect(() => {
    const performTranslation = async () => {
      if (language === 'en') {
        setTranslatedText(text);
        setLoading(false);
        return;
      }
      
      setLoading(true);
      setError(false);
      try {
        const result = await translate(text);
        setTranslatedText(result);
      } catch (error) {
        console.error('Translation error:', error);
        setTranslatedText(text); // Fallback to original
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    performTranslation();
  }, [text, language, translate]);

  return (
    <Component 
      className={`${className} ${loading ? 'animate-pulse opacity-70' : ''} ${error ? 'opacity-90' : ''} transition-opacity duration-200`}
    >
      {translatedText}
    </Component>
  );
};

export default TranslatedText;
